<cam-button type="secondary" [size]="this.size()" icon="Vector4" (action)="this.open()">
  @if (this.label(); as label) {
    {{ label }}
  }
</cam-button>

<cam-layout-full-panel
  [toggleState]="this.isOpen()"
  (closeEvent)="this.close()"
  [title]="'grid.fieldsselection.title' | translate"
>
  @if (this.isOpen()) {
    <ng-template [ngTemplateOutlet]="template"></ng-template>
  }
</cam-layout-full-panel>

<ng-template #template>
  <cam-fields-selection [gridId]="this.gridId()"></cam-fields-selection>
</ng-template>
